 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Companies~CustomEmailCreate~ServicesCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user":"Companies~CustomEmailCreate~ServicesCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user","Companies~CustomEmailCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user":"Companies~CustomEmailCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user","Companies":"Companies","CustomEmailCreate":"CustomEmailCreate","Sms":"Sms","Webhooks":"Webhooks","Whatsapp":"Whatsapp","WhatsappCompanies":"WhatsappCompanies","pagecedi":"pagecedi","user":"user","ServicesCreate":"ServicesCreate","CreateClient":"CreateClient","CustomEmail~CustomEmailEdit":"CustomEmail~CustomEmailEdit","CustomEmail":"CustomEmail","CustomEmailEdit":"CustomEmailEdit","demo_signup_pro":"demo_signup_pro","edituser":"edituser","error404":"error404","home":"home","login":"login","passwordreset":"passwordreset","recoverypassword":"recoverypassword","roles":"roles"}[chunkId]||chunkId) + "." + {"Companies~CustomEmailCreate~ServicesCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user":"40fd388c","Companies~CustomEmailCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user":"65efaae6","Companies":"eeb478ae","CustomEmailCreate":"cc009715","Sms":"fdc66ee0","Webhooks":"801f8a0d","Whatsapp":"a42c22f2","WhatsappCompanies":"f1f81f18","pagecedi":"8efb58f6","user":"58c0921c","ServicesCreate":"7c5b27cb","CreateClient":"d07b34e7","CustomEmail~CustomEmailEdit":"46a61b25","CustomEmail":"ef4c76c1","CustomEmailEdit":"bbb00f05","chunk-2bc966ca":"73fac5f7","chunk-69aa3efb":"68663065","demo_signup_pro":"ec8fc865","edituser":"e3bf7799","error404":"84a36440","home":"ee7a3916","login":"a6c5b191","passwordreset":"54d506be","recoverypassword":"475bc2d1","roles":"dc52b182","chunk-2c9259eb":"ced15ea8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Companies~CustomEmailCreate~ServicesCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user":1,"Companies~CustomEmailCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user":1,"Companies":1,"CustomEmailCreate":1,"Sms":1,"Webhooks":1,"Whatsapp":1,"WhatsappCompanies":1,"pagecedi":1,"user":1,"ServicesCreate":1,"CreateClient":1,"CustomEmail~CustomEmailEdit":1,"CustomEmail":1,"CustomEmailEdit":1,"chunk-2bc966ca":1,"chunk-69aa3efb":1,"demo_signup_pro":1,"edituser":1,"login":1,"recoverypassword":1,"roles":1,"chunk-2c9259eb":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Companies~CustomEmailCreate~ServicesCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user":"Companies~CustomEmailCreate~ServicesCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user","Companies~CustomEmailCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user":"Companies~CustomEmailCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user","Companies":"Companies","CustomEmailCreate":"CustomEmailCreate","Sms":"Sms","Webhooks":"Webhooks","Whatsapp":"Whatsapp","WhatsappCompanies":"WhatsappCompanies","pagecedi":"pagecedi","user":"user","ServicesCreate":"ServicesCreate","CreateClient":"CreateClient","CustomEmail~CustomEmailEdit":"CustomEmail~CustomEmailEdit","CustomEmail":"CustomEmail","CustomEmailEdit":"CustomEmailEdit","demo_signup_pro":"demo_signup_pro","edituser":"edituser","error404":"error404","home":"home","login":"login","passwordreset":"passwordreset","recoverypassword":"recoverypassword","roles":"roles"}[chunkId]||chunkId) + "." + {"Companies~CustomEmailCreate~ServicesCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user":"ba4a7382","Companies~CustomEmailCreate~Sms~Webhooks~Whatsapp~WhatsappCompanies~pagecedi~user":"bc035429","Companies":"d3dd0c72","CustomEmailCreate":"eaca55a2","Sms":"da0743c0","Webhooks":"57d9ed0a","Whatsapp":"ce4281c9","WhatsappCompanies":"ce4281c9","pagecedi":"24badd10","user":"da0743c0","ServicesCreate":"3e65fd9d","CreateClient":"3d87e425","CustomEmail~CustomEmailEdit":"3ee4ccb9","CustomEmail":"9775d971","CustomEmailEdit":"4e218a9b","chunk-2bc966ca":"2c705577","chunk-69aa3efb":"0ae6ee58","demo_signup_pro":"d7a40b8e","edituser":"d2a2fc95","error404":"31d6cfe0","home":"31d6cfe0","login":"ac4296f1","passwordreset":"31d6cfe0","recoverypassword":"9f0f73af","roles":"36c4ed5c","chunk-2c9259eb":"002d274c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
